/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointButtonIcon24Solid = forwardRef('HandPointButtonIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3 4a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-5V6.5a2.5 2.5 0 0 0-5 0V9H5a2 2 0 0 1-2-2V4Z" }),
        React.createElement("path", { d: "M9 6.5v8.25l-2.442-1.07a1.931 1.931 0 0 0-2.09 3.184l4.813 4.468a2.5 2.5 0 0 0 1.7.668h4.648a2.5 2.5 0 0 0 2.431-1.917l1.304-5.432a2.5 2.5 0 0 0-2.06-3.056L12 10.8V6.5a1.5 1.5 0 0 0-3 0Z" })));
});
